const colors = {
  'WHITE': '#FFF',
  'DARK_GRAY': '#DADADA',
  'LIGHT_GRAY': '#EEE',
  'KHAKI': '#FCF2D8',
  'RED': 'red',
  'BLUE': 'blue',
  'BLACK': 'black'
}

export { colors };
